import { render } from "./ProspectSiteSearch.vue?vue&type=template&id=4b5aaec0"
import script from "./ProspectSiteSearch.vue?vue&type=script&lang=js"
export * from "./ProspectSiteSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__